import React from "react";

import HelpCategories from "./help-categories";
import { useCommonContext } from "../../context/common-context";
import HelpWrapper from "./help-wrapper";

const restrictChatBanner = ["safeway","vons","albertsons","andronicos","haggen","balduccis","kingsfoodmarkets","tomthumb","shaws","randalls","carrsqc","pavilions","acmemarkets","jewelosco","starmarket","shopamigos","shopunitedsupermarkets","shopmarketstreet","shopalbertsonsmarket"];

const Help = ({}) => {
  const {
    user,
    appData: { banner },
    bannerFAQ,
    isGuest,
  } = useCommonContext();

  const totalFaq = bannerFAQ;
  const showChat = !(restrictChatBanner.includes(banner));
  
  return (
    <HelpWrapper faqList={totalFaq} showPartialChat={showChat} showChat={true}>
      <HelpCategories
        filterBy={""}
        isGuest={isGuest}
        banner={banner}
        user={user}
      />
    </HelpWrapper>
  );
};

export default Help;
